var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201703161753-430ad182f9-master/~/core-js/modules/_uid.js
// module id = 75
// module chunks = 1